<div class="prose-text-sm relative" clickOutside (onClickOutside)="closeDropdown()">
  <div
    class="pointer-events-none absolute left-3 flex -translate-y-1/2 gap-2 transition-[top] duration-300"
    [ngClass]="{
      'top-0': !!selected,
      'top-1/2': !selected,
      'text-gray-400': !selected,
      'prose-text-xs text-neutral-500': !!selected,
      'bg-neutral-200': isDisabled,
      'bg-transparent': isDisabled,
      'bg-white ': !isDisabled
    }">
    {{ label }}
    <span class="font-bold text-primary-500" *ngIf="required">*</span>
  </div>
  <div
    class="flex cursor-pointer items-center rounded-xl border border-neutral-200 px-3 py-4"
    [ngClass]="{
      'border-red-600': control.errors && control.touched,
      'border-neutral-200': !control.errors || !control.touched,
      'pointer-events-none  bg-neutral-200': isDisabled,
      'bg-white': !isDisabled
    }"
    (click)="isActive = !isActive">
    <span
      [ngClass]="{ 'w-[260px] truncate md:w-[240px]': multiple }"
      style="-webkit-line-clamp: 1; word-break: break-all"
      class="max-one-line">
      {{ displayValue }}
    </span>
    <ng-container *ngIf="!isDisabled">
      <app-icon name="chevron-down" class="ml-auto" fontSize="20" />
    </ng-container>
  </div>
  <div
    class="absolute z-20 hidden w-full rounded-xl border bg-white py-2 md:block"
    *ngIf="isActive"
    [ngClass]="{
      'bottom-[calc(100%+.5rem)]': topDropdown,
      'top-[calc(100%+.5rem)]': !topDropdown
    }">
    <div class="flex max-h-52 flex-col overflow-y-auto">
      <ng-content select="[top]"></ng-content>
      <div class="flex-1 overflow-y-auto">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="isActive"
  class="absolute inset-0 bg-black opacity-50 md:hidden"
  (click)="isActive = false; setTouched()"></div>
<div
  *ngIf="isActive"
  class="absolute inset-0 z-50 flex flex-col overflow-y-auto bg-white py-4 md:hidden"
  [ngClass]="{
    'mt-10': !isContainerPopup
  }">
  <div class="flex items-center gap-4 px-4">
    <button app-icon-button name="arrow-narrow-left" (click)="isActive = false"></button>
    <ng-content select="[header]"></ng-content>
  </div>
  <div class="flex-1 overflow-y-auto">
    <ng-content select="[mobile]"></ng-content>
  </div>
</div>
